import React from 'react';

const SchoolIcon: React.FC<{className?: string}> = ({ className }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className={className}>
        <path d="M11.25 4.533A9.707 9.707 0 0 0 6 3a9.735 9.735 0 0 0-3.25.555.75.75 0 0 0-.5.707v14.25a.75.75 0 0 0 1 .707A9.707 9.707 0 0 0 6 21a9.735 9.735 0 0 0 3.25-.555.75.75 0 0 0 .5-.707V5.25a.75.75 0 0 0-.5-.707Z" />
        <path d="M12.75 4.533A9.707 9.707 0 0 0 18 3a9.735 9.735 0 0 0 3.25.555.75.75 0 0 1 .5.707v14.25a.75.75 0 0 1-1 .707A9.707 9.707 0 0 1 18 21a9.735 9.735 0 0 1-3.25-.555.75.75 0 0 1-.5-.707V5.25a.75.75 0 0 1 .5-.707Z" />
    </svg>
  );
};

export default SchoolIcon;
